import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@/shared/components/input/Checkbox';
import intlShape from '@/shared/utils/intlShape';
import { StateService } from '@/shared/services/StateService';
import messages from './trainingMessages';
import FormattedListValue, { listItemMsg } from '@/shared/components/FormattedListValue';
import { IconPencil, PersonsIcon, DeleteIcon } from '@/shared/components/Icons';

const TrainingOverviewRow = ({
  training,
  intl,
  handleSelect,
  onEditTrainingClick,
  onUpdateTrainingEmployeesClick,
  onDeleteTrainingClick,
}) => {
  return (
    <tbody className="hover" key={training.Id} id={`RowID${training.Id}`}>
      <tr>
        <td>
          <Checkbox onClick={() => handleSelect(training)} value={training.selected} />
        </td>
        <td>
          <a
            title={intl.formatMessage(messages.EditTraining)}
            onClick={() => {
              onEditTrainingClick(training);
            }}
          >
            <b>{training.name}</b>
          </a>
        </td>
        <td>{training.resource.name}</td>
        <td>
          <FormattedListValue list="trainingType" id={training.type} />
        </td>
        <td>
          <FormattedListValue list="trainingStatus" id={training.status} />
        </td>
        <td>{training.durationHours}</td>
        <td>{intl.formatDate(training.startDate)}</td>
        <td>{intl.formatDate(training.endDate)}</td>
        <td>
          <i
            className={`fa ${training.mandatory ? 'fa-check text-success' : 'fa-times text-muted'}`}
          />
        </td>
        <td className="text-right">
          <a
            className="btn btn-xs btn-icon margin5R"
            title={intl.formatMessage(messages.EditTraining)}
            onClick={() => {
              onEditTrainingClick(training);
            }}
          >
            <IconPencil />
          </a>
          <a
            className="btn btn-xs btn-icon margin5R"
            title={intl.formatMessage(messages.AddUsers)}
            onClick={() => {
              onUpdateTrainingEmployeesClick(training);
            }}
          >
            <PersonsIcon />
          </a>
          <a
            className="btn btn-xs btn-icon"
            title={intl.formatMessage(messages.Delete)}
            onClick={() => {
              onDeleteTrainingClick(training);
            }}
          >
            <DeleteIcon />
          </a>
        </td>
      </tr>
    </tbody>
  );
};

TrainingOverviewRow.propTypes = {
  intl: intlShape.isRequired,
  training: PropTypes.object.isRequired,
  handleSelect: PropTypes.func.isRequired,
  stateService: PropTypes.instanceOf(StateService).isRequired,
};

export default TrainingOverviewRow;
